import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getClientDocumentType = createAsyncThunk("client/get-document-type", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/get-document-type`);
    // console.log("data", res.data.documenttype);
    return res.data.documenttype;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client documents");
  }
});

export const getClientDocumentList = createAsyncThunk("client/list-document", async (token, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/client/list-document`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    // console.log("data", res.data.client);
    return res.data.clientDocument;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch client documents");
  }
});

export const addClientDocument = createAsyncThunk("client/add-document", async ({ token, formData }, thunkAPI) => {
  try {
      const res = await axios.post(
        `${BACKEND_URL}/client/add-document`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to add client documents");
  }
});

export const deleteClientDocument = createAsyncThunk(
  "client/delete-document-detail",
  async ({ token, documentId  }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/client/delete-document-detail/${documentId }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to delete client documents"
      );
    }
  }
);

export const updateClientDocument = createAsyncThunk(
  "client/update-document-detail",
  async ({ token, documentData, documentId }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/client/update-document-detail/${documentId}`,
        documentData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to update client documents"
      );
    }
  }
);

const clientDocumentSlice = createSlice({
  name: "clientDocument",
    initialState: {
      clientsDocument: null,
      clientDocumentType: null,
      loading: false,
      error: null,
    },
    extraReducers: (builder) => {
      builder
        .addCase(getClientDocumentList.pending, (state) => {
            state.loading = true;
        })
        .addCase(getClientDocumentList.fulfilled, (state, action) => {
            state.clientsDocument = action.payload;
            state.loading = false;
        })
        .addCase(getClientDocumentList.rejected, (state, action) => {
            state.error = action.payload || "Failed to fetch client documents"; 
            state.loading = false;
        })
        .addCase(addClientDocument.pending, (state) => {
          state.loading = true;
        })
        .addCase(addClientDocument.fulfilled, (state, action) => {
          state.clientsDocument = action.payload.clientDocument;
           state.loading = false;
        })
        .addCase(addClientDocument.rejected, (state, action) => {
          state.error = action.payload || "Failed to add client documents";
          state.loading = false;
        })
        .addCase(deleteClientDocument.pending, (state) => {
          state.loading = true;
        })
        .addCase(deleteClientDocument.fulfilled, (state, action) => {
          state.clientsDocument = state.clientsDocument.filter(doc => doc.id !== action.meta.arg.documentId);
          state.loading = false;
        })
        .addCase(deleteClientDocument.rejected, (state, action) => {
          state.error = action.payload || "Failed to delete client documents";
          state.loading = false;
        })
        .addCase(getClientDocumentType.fulfilled, (state, action) => {
          state.clientDocumentType = action.payload;
        })
        .addCase(getClientDocumentType.rejected, (state, action) => {
          state.error = action.payload;
        })
    },
});

export default clientDocumentSlice.reducer;